import React, { useContext, useEffect, useRef, useState } from "react";
import { Table } from "reactstrap";
import { CarDocumentDownload, getCarDocuments } from "../../../Services/Car.service";
import { showAlert } from "../../../Services/Shared.service";
import { H6 } from "../../../AbstractElements";
import { Link } from "react-router-dom";
import { Download } from "react-feather";
import { getDriverDocuments } from "../../../Services/DispatchDashboard.service";
import { driverDocumentDownload } from "../../../Services/Driver.service";
import CustomizerContext from "../../../_helper/Customizer";


const DriveDocuments = ({ driverId }) => {

    const [uploadedFiles, setUploadedFiles] = useState([])
    const downloadFileRef = useRef(null);
    const [downloadFileUrl, setDownloadFileUrl] = useState("");
    const [downloadFileName, setDownloadFileName] = useState("");
    const {mix_background_layout} = useContext(CustomizerContext)
    

    useEffect(() => {
        getDriverDocuments(driverId).then((result) => {
            setUploadedFiles(result.data)
        }).catch((err) => {
            showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
        });
    }, [])

    const downloadDocument = (file) => {
        let obj = {
            key: file.key,
            fileName: file.fileName,
            driverId: driverId
        }
        driverDocumentDownload(obj).then((result) => {
            let fileUrl = result.data.split(": ")[1]
            setDownloadFileUrl(fileUrl)
            setDownloadFileName(file.fileName)
            downloadFileRef.current?.click();
        }).catch((err) => {
            showAlert("error", err.response?.data?.message ? err.response.data.message : "Something went wrong");
        });
    }

    return (
        <>
            <Table style={{ margin: "20px 0px" }} bordered dark={mix_background_layout == "dark-only" ? true : false}>
                <thead><tr></tr></thead>
                <tbody>
                    {uploadedFiles && uploadedFiles.length ?
                        [...uploadedFiles].map((file, i) => {
                            return (
                                <tr key={i} >
                                    <td style={{display: "flex",cursor: "pointer",color: mix_background_layout == "dark-only" ? "white" : null}}>
                                        <H6 attrH6={{ className: 'task_title_0', onClick: () => downloadDocument(file) }} >{file.fileName}</H6><Download size={"18"} style={{marginLeft: "15px"}} onClick={() => downloadDocument(file)}/>
                                    </td>
                                </tr>
                            );
                        })
                        : <tr><td style={{color: mix_background_layout == "dark-only" ? "white" : null}}><div className="no-favourite"><span>{"No Documents Uploaded"}</span></div></td></tr>
                    }
                </tbody>

            </Table>
            <a
                href={downloadFileUrl}
                download={downloadFileName}
                style={{ display: "none" }}
                ref={downloadFileRef}
            />
        </>
    )
}

export default DriveDocuments